// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"e5e47b65","446":"50748569"}[chunkId] + ".chunk.js";
};